<div class="grid-x grid-margin-x teaser" *ngIf="shortVersion === false">
  <div class="cell small-12 medium-6 large-4 large-offset-2">
    <h1 class="hide-for-medium">{{ 'moderat.einstieg.stepheadline' | translate: welcomePlaceholder }}</h1>
    <app-advisor-image path="/moc/moc-teaser.svg" [altText]="'moderat.einstieg.alt_text' | translate"></app-advisor-image>
  </div>
  <div class="cell small-12 medium-6 large-5">
    <h1 class="show-for-medium">{{ 'moderat.einstieg.stepheadline' | translate : welcomePlaceholder }}</h1>
    <div class="callout" [innerHTML]="'moderat.einstieg.teaser' | translate"></div>
  </div>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <h2>{{ 'moderat.external.fields.headline' | translate }}</h2>
  <div class="external-formfield-wrapper">
    <div class="grid-x grid-margin-x grid-margin-y">
      <div class="cell {{field.classes}}" *ngFor="let field of fieldConfig">
        <div class="formfield">
          <div *ngIf="field.type !== 'checkbox'">
            <label [innerHTML]="field.label" [for]="field.name"></label>
            <div class="input-group">
              <input [type]="field.type" class="input-group-field" [id]="field.name" [formControlName]="field.name">
            </div>
          </div>
          <div class="checkbox-simple" *ngIf="field.type === 'checkbox'">
            <input type="checkbox" [id]="field.name" [name]="field.name" value="1" [formControlName]="field.name" [required]="field.required">
            <label [for]="field.name" [innerHTML]="field.label"></label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <h2>{{ 'moderat.einstieg.selection.headline' | translate }}</h2>
  <div class="grid-x grid-margin-x grid-margin-y">
    <div class="cell xsmall-12 small-6" *ngFor="let interest of interestList">
      <div class="radio-button">
        <input type="radio" name="interesse" [id]="'interesse_' + interest" [value]="interest" formControlName="interesse">
        <label [for]="'interesse_' + interest" (click)="interestSelected()">
          <app-advisor-image [path]="'/moc/moc-einstieg-' + interest + '.svg'" [altText]="'moderat.einstieg.interesse.alt_text.' + interest | translate"></app-advisor-image>
          <span [innerHTML]="'moderat.einstieg.interesse.' + interest | translate"></span>
        </label>
      </div>
    </div>
  </div>

  <div #submitWrapper>
    <div class="massnahmen-wrapper" *ngIf="form?.get('interesse').value === 'massnahme'">
      <h3>{{ 'moderat.einstieg.interesse.headline' | translate }}</h3>
      <div class="grid-x grid-margin-x grid-margin-y">
        <div class="cell small-12 medium-6 large-4" *ngFor="let measure of measureList">
          <mat-checkbox (change)="selectMeasure($event)" [value]="measure" [checked]="hasMeasure(measure)" class="checkbox-button" color="primary">{{'moderat.massnahme.' + measure | translate}}</mat-checkbox>
        </div>
      </div>
    </div>

    <div class="button-wrapper" [class.background]="form?.get('interesse').valid">
      <div *ngIf="form.get('interesse').valid" [innerHTML]="'moderat.einstieg.submit.teaser.' + form.get('interesse').value | translate"></div>
      <div *ngIf="showError && form.valid === false" role="alert" class="form-errors" [innerHTML]="'moderat.external.submit.error' | translate">Bitte wählen Sie eine der beiden Optionen bei "Was möchten Sie prüfen?"</div>
      <button *ngIf="shortVersion === false" type="submit" class="button inline-arrow-right" (click)="onSubmitClick()" [class.disabled]="!form.valid">{{ 'moderat.einstieg.submit' | translate }}</button>
      <a [href]="shortVersionButtonUrl" (click)="saveData()" *ngIf="shortVersion === true" [class.disabled]="!form.valid" class="button inline-arrow-right" target="_blank">{{ 'moderat.einstieg.submit' | translate }}</a>
    </div>
  </div>
</form>

